import tmhRequest from '@/config/tmhRequest'


export default {
    searchStoreEmployee: function (data) {
        return tmhRequest({
            url: '/employee/tmh/storeemployee/searchstoreemployee',
            method: 'post',
            params: data,
        })
    },
    searchListStoreEmployee: function (data) {
        return tmhRequest({
            url: '/employee/tmh/storeemployee/searchliststoreemployee',
            method: 'post',
            params: data,
        })
    },

    searchStoreEmployeeWithPart: function (data) {
        return tmhRequest({
            url: '/employee/tmh/storeemployee/searchstoreemployeewithpart',
            method: 'post',
            params: data,
        })
    },

    searchListSpecialStoreEmployee: function (data) {
        return tmhRequest({
            url: '/employee/tmh/storeemployee/searchlistspecialstoreemployee',
            method: 'post',
            params: data,
        })
    },

    searchStoreEmployeeCount: function (data) {
        return tmhRequest({
            url: '/employee/tmh/storeemployee/searchstoreemployeecount',
            method: 'post',
            data: data,
        })
    },

    searchStoreEmployeeByPage: function (data) {
        return tmhRequest({
            url: '/employee/tmh/storeemployee/searchstoreemployeebypage',
            method: 'post',
            data: data,
        })
    },
    editStoreEmployee: function (data) {
        return tmhRequest({
            url: '/employee/tmh/storeemployee/editstoreemployee',
            method: 'post',
            data: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/employee/storeemployee.js